import { create } from 'zustand';

export type AppStore = {
  key: string;
};

export const useAppStore = create<AppStore>(() => ({
  key: '',
}));
